// extracted by mini-css-extract-plugin
module.exports = {"halfRhythm":"14px","picture":"picture-module--picture--3meDa"};